
const project = {
  state: {
    project:null,
    processRow:null
  },

  mutations: {
    SET_PROJECT: (state, project) => {
      state.project = project
    },
    SET_PROCESSROW: (state, processRow) => {
      state.processRow = processRow
    },
  },

  actions: {
    
    getProject( { commit } ) {
      return state.project
    },
    getProcess( { commit } ) {
      return state.processRow
    },
  }
}

export default project
